export default __webpack_public_path__ + "static/media/HistoricSubject.0aa85acf.svg";